module.exports = __webpack_public_path__ + "static/img/wang.1671bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wang.jpg
// module id = iqSN
// module chunks = 1